// extracted by mini-css-extract-plugin
module.exports = {"root":"Gp8rM","grid":"_2yRg7","sidebar":"_1iqer","v0Results":"_2QRdh"};